<div #slider class="slider  slider--undefined">
  <div class="slider__bar">
    @for (val of values; track val) {
      <div #progress class="scale-btn" [ngStyle]="{'width': widthOfInterval}" [ngClass]="buttonClass(val)" (click)="setValue(val)" (mouseenter)="mouseEnter(val)" (mouseleave)="mouseLeave(val)">{{val}}</div>
    }
  </div>
  @if (disabled==false && showTicks==true) {
    <div #increments class="slider__increments" [ngStyle]="incrementSizeStyle">
      @for (i of values; track i) {
        <div>|</div>
      }
    </div>
  }

  <div class="slider__labels">
    <div class="slider-label  slider-label--start">{{startLabel}}</div>
    <div class="slider-label  slider-label--end" (click)="showTicks = !showTicks">{{endLabel}}</div>
  </div>
  @if (value == undefined || value == 0) {
    <div class="slider__prompt">
      Select
    </div>
  }
</div>
